(function (scope) {
  'use strict';

  var DAYS_IN_ROUTINE = 84;
  // Subscriptions ship on one fixed plan: every 30 days.
  var DELIVERY_DAYS = 30;
  var CM_PER_ROLL = 150;
  var CM_PER_INCH = 2.54;
  // Kaching bundle sizes on the PDP, smallest first.
  var PACK_SIZES = [1, 3, 4];
  var KACHING_PACK_LABELS = {
    1: [/\b1\s*pack\b/i, /\b1\s*roll\b/i, /\bsingle\s*(pack|roll)\b/i],
    3: [/\b2\s*\+\s*1\s*pack\b/i, /\b3\s*(pack|rolls?)\b/i, /\bbuy\s*2\s*get\s*1\b/i],
    4: [/\b2\s*\+\s*2\s*pack\b/i, /\b4\s*(pack|rolls?)\b/i, /\bbuy\s*2\s*get\s*2\b/i]
  };

  // The pack is the smallest one that lasts a full delivery cycle at one strip
  // a day. A scar long enough to need more than the largest pack still gets
  // the largest pack; daysCovered says how much of the cycle it lasts.
  function calculateRecommendation(totalScarCm) {
    // The epsilon stops float noise (e.g. 3.0000000000000004) rounding up a pack.
    var requiredRolls = Math.ceil((totalScarCm * DAYS_IN_ROUTINE) / CM_PER_ROLL - 1e-9);
    var rollsPerDelivery = Math.ceil((totalScarCm * DELIVERY_DAYS) / CM_PER_ROLL - 1e-9);
    var bundleRolls = PACK_SIZES.find(function (size) { return size >= rollsPerDelivery; }) ||
      PACK_SIZES[PACK_SIZES.length - 1];

    return {
      totalScarCm: totalScarCm,
      requiredRolls: requiredRolls,
      rollsPerDelivery: rollsPerDelivery,
      bundleRolls: bundleRolls,
      deliveryDays: DELIVERY_DAYS,
      daysCovered: Math.floor((bundleRolls * CM_PER_ROLL) / totalScarCm)
    };
  }

  function formatNumber(number) {
    var rounded = Math.round(number * 10) / 10;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { calculateRecommendation: calculateRecommendation, formatNumber: formatNumber };
  }

  if (!scope || !scope.document || !scope.customElements) return;

  scope.AmueeSupplyCalculatorLogic = {
    calculateRecommendation: calculateRecommendation,
    formatNumber: formatNumber
  };

  function textOf(element) {
    return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function deepQueryAll(boundary, selector) {
    if (!boundary || !selector) return [];
    var matches = [];
    var roots = [boundary];
    var visited = [];

    while (roots.length) {
      var root = roots.shift();
      if (!root || visited.indexOf(root) !== -1) continue;
      visited.push(root);

      if (root.matches && root.matches(selector)) matches.push(root);
      if (!root.querySelectorAll) continue;
      Array.prototype.forEach.call(root.querySelectorAll(selector), function (element) {
        if (matches.indexOf(element) === -1) matches.push(element);
      });
      Array.prototype.forEach.call(root.querySelectorAll('*'), function (element) {
        if (element.shadowRoot) roots.push(element.shadowRoot);
      });
    }

    return matches;
  }

  function deepQuery(boundary, selector) {
    return deepQueryAll(boundary, selector)[0] || null;
  }

  function isVisible(element) {
    if (!element || element.disabled) return false;
    var style = scope.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  }

  function isInsideBoundary(boundary, element) {
    var current = element;
    while (current) {
      if (current === boundary) return true;
      var root = current.getRootNode ? current.getRootNode() : null;
      current = current.parentElement || (root && root.host ? root.host : null);
    }
    return false;
  }

  function escapeSelector(value) {
    return scope.CSS && typeof scope.CSS.escape === 'function'
      ? scope.CSS.escape(value)
      : String(value).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function controlText(control) {
    if (!control) return '';
    var parts = [
      textOf(control),
      control.getAttribute && control.getAttribute('aria-label'),
      control.getAttribute && control.getAttribute('title'),
      control.getAttribute && control.getAttribute('data-title'),
      control.getAttribute && control.getAttribute('data-label'),
      control.value
    ];
    var root = control.getRootNode ? control.getRootNode() : document;
    if (control.id && root && root.querySelector) {
      parts.push(textOf(root.querySelector('label[for="' + escapeSelector(control.id) + '"]')));
    }
    var parentLabel = control.closest ? control.closest('label') : null;
    if (parentLabel) parts.push(textOf(parentLabel));
    if (control.matches && control.matches('input') && !parentLabel && control.parentElement) {
      parts.push(textOf(control.parentElement));
    }
    return parts.filter(Boolean).join(' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function inputChoiceText(input, boundary) {
    var parts = [controlText(input)];
    var current = input ? input.parentElement : null;
    var depth = 0;

    while (current && depth < 5 && isInsideBoundary(boundary, current)) {
      var radios = deepQueryAll(current, 'input[type="radio"], input[type="checkbox"]');
      if (radios.length === 1) {
        parts.push(textOf(current));
        break;
      }
      current = current.parentElement;
      depth += 1;
    }

    return parts.filter(Boolean).join(' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function dispatchInputEvents(input) {
    input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }

  function clickableFrom(element, boundary) {
    if (!element) return null;
    var clickable = element.closest('button, label, [role="button"], [role="radio"], [role="checkbox"], input');
    return clickable && isInsideBoundary(boundary, clickable) && isVisible(clickable) ? clickable : null;
  }

  function findTextControl(boundary, matcher) {
    if (!boundary) return null;
    var controls = deepQueryAll(boundary, 'button, label, [role="button"], [role="radio"], [role="checkbox"], input');
    for (var i = 0; i < controls.length; i += 1) {
      var control = controls[i];
      var labelText = controlText(control);
      if (matcher(labelText, control) && isVisible(control)) return clickableFrom(control, boundary) || control;
    }
    return null;
  }

  function activateControl(control) {
    if (!control) return false;
    control.click();
    if (control.matches('input, select')) {
      dispatchInputEvents(control);
    }
    return true;
  }

  function nextPaint() {
    return new Promise(function (resolve) {
      scope.requestAnimationFrame(function () {
        scope.setTimeout(resolve, 80);
      });
    });
  }

  class AmueeSupplyCalculator extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ascReady === 'true') return;
      this.dataset.ascReady = 'true';

      this.state = {
        step: 1,
        scarCount: 1,
        unit: 'cm',
        lengthsCm: [null, null, null, null, null],
        recommendation: null
      };

      this.trigger = this.querySelector('[data-asc-open]');
      this.dialog = this.querySelector('.asc__dialog');
      this.handoff = this.querySelector('[data-asc-handoff]');
      this.error = this.querySelector('[data-asc-error]');
      this.lengths = this.querySelector('[data-asc-lengths]');
      this.progress = this.querySelector('[data-asc-progress]');
      this.countOutput = this.querySelector('[data-asc-count-value]');
      this.topBack = this.querySelector('[data-asc-top-back]');
      this.sellingPlans = this.readSellingPlans();

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('input', this.onInput.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      this.dialog.addEventListener('cancel', this.onCancel.bind(this));
      this.dialog.addEventListener('click', this.onBackdropClick.bind(this));
      this.updateCount();
      this.positionBesideBenefits();
    }

    positionBesideBenefits() {
      var productInfo = this.closest('product-info') || document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('[id^="ProductInfo-"]');
      if (!productInfo) return;
      var benefits = productInfo.querySelector('.amuee-itabs__benefits');
      if (!benefits || benefits.contains(this)) return;
      var benefitsPanel = benefits.querySelector('[data-itabs-expander-panel]');
      benefits.classList.add('asc-benefits-row');
      benefits.insertBefore(this, benefitsPanel || null);
    }

    onClick(event) {
      var button = event.target.closest('button');
      if (!button || !this.contains(button)) return;

      if (button.matches('[data-asc-open]')) {
        this.lastTrigger = button;
        this.open();
      } else if (button.matches('[data-asc-close]')) this.close();
      else if (button.matches('[data-asc-top-back]')) this.showStep(Math.max(1, this.state.step - 1));
      else if (button.matches('[data-asc-count="decrease"]')) this.setScarCount(this.state.scarCount - 1);
      else if (button.matches('[data-asc-count="increase"]')) this.setScarCount(this.state.scarCount + 1);
      else if (button.matches('[data-asc-next]')) {
        this.renderLengthInputs();
        this.showStep(2);
      } else if (button.matches('[data-asc-back]')) this.showStep(1);
      else if (button.matches('[data-asc-result-back]')) this.showStep(2);
      else if (button.matches('[data-asc-unit]')) this.setUnit(button.dataset.ascUnit);
      else if (button.matches('[data-asc-calculate]')) this.calculate();
      else if (button.matches('[data-asc-apply]')) this.applyRecommendation();
      else if (button.matches('[data-asc-options]')) this.closeAndScrollToOptions();
    }

    onInput(event) {
      var input = event.target.closest('[data-asc-length]');
      if (!input) return;
      var index = Number(input.dataset.ascLength);
      var value = input.valueAsNumber;
      this.state.lengthsCm[index] = Number.isFinite(value) && value > 0
        ? value * (this.state.unit === 'in' ? CM_PER_INCH : 1)
        : null;
      input.removeAttribute('aria-invalid');
      this.clearError();
    }

    onKeydown(event) {
      if (event.target.matches('[data-asc-length]') && ['e', 'E', '+', '-'].includes(event.key)) {
        event.preventDefault();
      }
    }

    onCancel(event) {
      event.preventDefault();
      this.close();
    }

    onBackdropClick(event) {
      if (event.target === this.dialog) this.close();
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
      this.showStep(this.state.step, false);
    }

    close() {
      if (this.dialog.open) this.dialog.close();
      this.trigger.setAttribute('aria-expanded', 'false');
      // Focus goes back to the trigger that opened the dialog.
      (this.lastTrigger || this.trigger).focus({ preventScroll: true });
    }

    showStep(step, focusHeading) {
      this.state.step = step;
      var panels = this.querySelectorAll('[data-asc-panel]');
      panels.forEach(function (panel) {
        panel.hidden = Number(panel.dataset.ascPanel) !== step;
      });
      this.progress.style.setProperty('--asc-progress', (step / 3) * 100 + '%');
      if (this.topBack) this.topBack.hidden = step === 1;
      this.clearError();
      if (focusHeading !== false) {
        var heading = this.querySelector('[data-asc-panel="' + step + '"] .asc__heading');
        if (heading) scope.setTimeout(function () { heading.focus({ preventScroll: true }); }, 0);
      }
    }

    readSellingPlans() {
      var script = this.querySelector('[data-asc-selling-plans]');
      if (!script) return [];
      try {
        var plans = JSON.parse(script.textContent || '[]');
        return Array.isArray(plans) ? plans : [];
      } catch (error) {
        return [];
      }
    }

    setScarCount(count) {
      this.state.scarCount = Math.max(1, Math.min(5, count));
      this.updateCount();
    }

    updateCount() {
      this.countOutput.textContent = String(this.state.scarCount);
      var minus = this.querySelector('[data-asc-count="decrease"]');
      var plus = this.querySelector('[data-asc-count="increase"]');
      minus.disabled = this.state.scarCount <= 1;
      plus.disabled = this.state.scarCount >= 5;
    }

    setUnit(unit) {
      if (unit !== 'cm' && unit !== 'in') return;
      this.state.unit = unit;
      this.querySelectorAll('[data-asc-unit]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.ascUnit === unit));
      });
      this.renderLengthInputs();
    }

    renderLengthInputs() {
      var fragment = document.createDocumentFragment();
      var unit = this.state.unit;
      var max = unit === 'cm' ? 200 : 80;

      for (var i = 0; i < this.state.scarCount; i += 1) {
        var label = document.createElement('label');
        label.className = 'asc__field';

        var labelText = document.createElement('span');
        labelText.className = 'asc__field-label';
        labelText.textContent = 'Scar ' + (i + 1);

        var wrap = document.createElement('span');
        wrap.className = 'asc__input-wrap';

        var input = document.createElement('input');
        input.className = 'asc__length-input';
        input.type = 'number';
        input.inputMode = 'decimal';
        input.min = '0.1';
        input.max = String(max);
        input.step = '0.1';
        input.placeholder = unit === 'cm' ? '10' : '4';
        input.dataset.ascLength = String(i);
        input.setAttribute('aria-label', 'Scar ' + (i + 1) + ' length in ' + (unit === 'cm' ? 'centimeters' : 'inches'));
        if (this.state.lengthsCm[i] !== null) {
          input.value = formatNumber(unit === 'cm' ? this.state.lengthsCm[i] : this.state.lengthsCm[i] / CM_PER_INCH);
        }

        var unitLabel = document.createElement('span');
        unitLabel.className = 'asc__input-unit';
        unitLabel.textContent = unit;

        wrap.appendChild(input);
        wrap.appendChild(unitLabel);
        label.appendChild(labelText);
        label.appendChild(wrap);
        fragment.appendChild(label);
      }

      this.lengths.replaceChildren(fragment);
    }

    clearError() {
      if (this.error) this.error.textContent = '';
    }

    showError(message, invalidInputs) {
      this.error.textContent = message;
      (invalidInputs || []).forEach(function (input) {
        input.setAttribute('aria-invalid', 'true');
      });
      if (invalidInputs && invalidInputs[0]) invalidInputs[0].focus();
    }

    calculate() {
      var inputs = Array.from(this.querySelectorAll('[data-asc-length]'));
      var max = this.state.unit === 'cm' ? 200 : 80;
      var missing = inputs.filter(function (input) {
        return !Number.isFinite(input.valueAsNumber) || input.valueAsNumber <= 0;
      });
      if (missing.length) {
        this.showError('Please enter the length of each scar.', missing);
        return;
      }

      var tooLarge = inputs.filter(function (input) { return input.valueAsNumber > max; });
      if (tooLarge.length) {
        this.showError('Please check that measurement. Enter up to ' + max + ' ' + this.state.unit + ' per scar.', tooLarge);
        return;
      }

      var totalCm = this.state.lengthsCm.slice(0, this.state.scarCount).reduce(function (sum, value) {
        return sum + value;
      }, 0);
      if (totalCm > 500) {
        this.showError('That total looks unusually long. Please check each measurement.', inputs);
        return;
      }

      this.state.recommendation = calculateRecommendation(totalCm);
      this.renderRecommendation();
      this.showStep(3);
    }

    renderRecommendation() {
      var result = this.state.recommendation;
      var totalLabel;
      if (this.state.unit === 'in') {
        totalLabel = formatNumber(result.totalScarCm / CM_PER_INCH) + ' in (' + formatNumber(result.totalScarCm) + ' cm)';
      } else {
        totalLabel = formatNumber(result.totalScarCm) + ' cm';
      }

      this.querySelector('[data-asc-total]').textContent = totalLabel;
      this.querySelector('[data-asc-rolls]').textContent = result.requiredRolls + (result.requiredRolls === 1 ? ' roll' : ' rolls');
      this.querySelector('[data-asc-bundle]').textContent = result.bundleRolls + (result.bundleRolls === 1 ? ' roll' : ' rolls') + ' per shipment';
      this.querySelector('[data-asc-schedule]').textContent = 'Every ' + result.deliveryDays + ' days';

      var shortfall = this.querySelector('[data-asc-shortfall]');
      if (shortfall) {
        var short = result.daysCovered < result.deliveryDays;
        shortfall.textContent = short
          ? result.bundleRolls + ' rolls is our largest pack. At your scar length it lasts about ' +
            result.daysCovered + ' days, so you may want extra rolls between deliveries.'
          : '';
        shortfall.hidden = !short;
        shortfall.style.display = short ? '' : 'none';
      }
      this.querySelector('[data-asc-apply-status]').textContent = '';
    }

    findProductInfo() {
      return this.closest('product-info') || document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('[id^="ProductInfo-"]');
    }

    findProductForm() {
      var productInfo = this.findProductInfo();
      if (!productInfo) return null;
      var addButton = productInfo.querySelector('.product-form__submit, [name="add"]');
      if (addButton) {
        if (addButton.form) return addButton.form;
        var formId = addButton.getAttribute('form');
        if (formId) return document.getElementById(formId);
      }
      return productInfo.querySelector('form[action*="/cart/add"]');
    }

    findKachingBundleBoundary() {
      var productInfo = this.findProductInfo();
      if (!productInfo) return null;
      return deepQuery(productInfo, 'kaching-bundles-block') ||
        deepQuery(productInfo, 'kaching-bundle') ||
        deepQuery(productInfo, '.kaching-bundles__bars') ||
        deepQuery(productInfo, '[class*="kaching-bundles"]') ||
        deepQuery(productInfo, '[data-kaching-bundle]');
    }

    findKachingSubscriptionBoundary() {
      var productInfo = this.findProductInfo();
      if (!productInfo) return null;
      return deepQuery(productInfo, 'kaching-subscriptions') ||
        deepQuery(productInfo, '[class*="kaching-subscription"]') ||
        this.findKachingBundleBoundary() ||
        productInfo;
    }

    async waitForKaching() {
      var started = Date.now();
      var boundary = this.findKachingBundleBoundary();
      while (!boundary && Date.now() - started < 2500) {
        await new Promise(function (resolve) { scope.setTimeout(resolve, 120); });
        boundary = this.findKachingBundleBoundary();
      }
      return boundary;
    }

    findOptionsTarget() {
      return this.findKachingBundleBoundary() || this.findKachingSubscriptionBoundary() || this;
    }

    async selectBundle(bundleRolls) {
      var boundary = this.findKachingBundleBoundary();
      if (!boundary) return false;

      var explicit = deepQuery(boundary,
        '[data-quantity="' + bundleRolls + '"], ' +
        '[data-bundle-quantity="' + bundleRolls + '"], ' +
        '[data-deal-quantity="' + bundleRolls + '"]'
      );
      var control = clickableFrom(explicit, boundary);
      if (!control) {
        var patterns = KACHING_PACK_LABELS[bundleRolls] || [new RegExp('\\b' + bundleRolls + '\\s*(pack|rolls?)\\b', 'i')];
        control = findTextControl(boundary, function (text) {
          return patterns.some(function (pattern) { return pattern.test(text); });
        });
      }
      if (!control) return false;

      var eventTarget = deepQuery(this.findProductInfo(), 'kaching-bundles-block') || boundary;
      var dealSelected = false;
      var onDealSelected = function () { dealSelected = true; };
      if (eventTarget && eventTarget.addEventListener) eventTarget.addEventListener('deal-bar-selected', onDealSelected);
      var activated = activateControl(control);
      await nextPaint();
      if (eventTarget && eventTarget.removeEventListener) eventTarget.removeEventListener('deal-bar-selected', onDealSelected);

      return activated || dealSelected;
    }

    async selectSubscription() {
      var productInfo = this.findProductInfo();
      if (!productInfo) return false;

      var subscriptionBlocks = deepQueryAll(productInfo, '.kaching-bundles__subscriptions');
      var isSelected = function (element) {
        return !!element && (
          element.classList.contains('kaching-bundles__bar--selected') ||
          element.getAttribute('aria-checked') === 'true'
        );
      };
      var isSubscribeChoice = function (element) {
        var title = deepQuery(element, '.kaching-bundles__subscriptions__title');
        var text = textOf(title || element);
        return /subscribe|subscription|save\s*\d|never\s*run\s*out/.test(text) && !/one[ -]?time|single purchase/.test(text);
      };

      for (var blockIndex = 0; blockIndex < subscriptionBlocks.length; blockIndex += 1) {
        var block = subscriptionBlocks[blockIndex];
        var checkbox = deepQuery(block, '[role="checkbox"]');
        if (checkbox) {
          if (isSelected(checkbox)) return true;
          checkbox.click();
          await nextPaint();
          if (isSelected(checkbox)) return true;
        }

        var bars = deepQueryAll(block, '.kaching-bundles__bar');
        var subscribeBar = bars.find(isSubscribeChoice);
        if (!subscribeBar && bars.length > 1) {
          subscribeBar = bars.find(function (bar) {
            return !/one[ -]?time|single purchase/.test(textOf(bar));
          }) || bars[bars.length - 1];
        }
        if (subscribeBar) {
          if (isSelected(subscribeBar)) return true;
          subscribeBar.click();
          await nextPaint();
          if (isSelected(subscribeBar)) return true;

          var refreshedBlock = deepQueryAll(productInfo, '.kaching-bundles__subscriptions')[blockIndex];
          var refreshedBar = refreshedBlock
            ? deepQueryAll(refreshedBlock, '.kaching-bundles__bar').find(isSubscribeChoice)
            : null;
          if (isSelected(refreshedBar)) return true;
        }
      }

      var inputs = deepQueryAll(productInfo, 'input[type="radio"], input[type="checkbox"]');
      var candidates = inputs.map(function (input) {
        var own = [
          input.value,
          input.id,
          input.name,
          input.getAttribute('aria-label'),
          input.getAttribute('data-purchase-option'),
          input.getAttribute('data-selling-plan'),
          input.getAttribute('data-type')
        ].filter(Boolean).join(' ').toLowerCase();
        var optionText = inputChoiceText(input, productInfo);
        var score = 0;
        if (/subscribe\s*(?:&|and)?\s*save|subscription|subscribe/.test(own)) score += 10;
        if (/subscribe\s*(?:&|and)?\s*save|subscription|subscribe/.test(optionText)) score += 6;
        if (/one[ -]?time|single purchase/.test(own)) score -= 12;
        if (/one[ -]?time|single purchase/.test(optionText) && !/subscribe|subscription/.test(optionText)) score -= 8;
        if (input.disabled) score -= 20;
        return { input: input, text: optionText, score: score };
      }).filter(function (candidate) { return candidate.score > 0; });

      candidates.sort(function (a, b) { return b.score - a.score; });
      var candidate = candidates[0];
      if (candidate) {
        var input = candidate.input;
        if (input.checked) return true;

        var optionContainer = input.closest('label, button, [role="radio"], [role="button"]');
        if (!optionContainer) {
          var current = input.parentElement;
          var depth = 0;
          while (current && depth < 5 && isInsideBoundary(productInfo, current)) {
            var optionInputs = deepQueryAll(current, 'input[type="radio"], input[type="checkbox"]');
            if (optionInputs.length === 1 && /subscribe|subscription/.test(textOf(current))) {
              optionContainer = current;
              break;
            }
            current = current.parentElement;
            depth += 1;
          }
        }

        if (optionContainer && optionContainer !== input) optionContainer.click();
        if (!input.checked) input.click();
        if (!input.checked) input.checked = true;
        dispatchInputEvents(input);
        await nextPaint();
        if (input.checked) return true;
      }

      var control = findTextControl(productInfo, function (text, element) {
        if (!/subscribe\s*(?:&|and)?\s*save|subscription|subscribe/.test(text)) return false;
        if (/learn|details|terms|why/.test(text)) return false;
        return element.matches('label, button, [role="radio"], [role="checkbox"], [role="button"]');
      });
      if (!activateControl(control)) return false;
      await nextPaint();

      return deepQueryAll(productInfo, 'input[type="radio"], input[type="checkbox"]').some(function (input) {
        return input.checked && /subscribe|subscription/.test(inputChoiceText(input, productInfo));
      });
    }

    // The 30-day plan - the product's only one, so there is no interval to
    // pick. Kaching normally sets it when Subscribe is chosen; writing it to
    // the form as well covers the case where it doesn't.
    findSellingPlan() {
      var pattern = new RegExp('\\b' + DELIVERY_DAYS + '\\s*days?\\b|\\bmonth', 'i');
      return this.sellingPlans.find(function (plan) {
        return pattern.test([plan.name, JSON.stringify(plan.options || [])].join(' '));
      }) || this.sellingPlans[0] || null;
    }

    applySellingPlan() {
      var plan = this.findSellingPlan();
      var form = this.findProductForm();
      if (!plan || !form) return false;

      var fields = Array.from(form.querySelectorAll('[name="selling_plan"]'));
      if (!fields.length) {
        var field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'selling_plan';
        field.dataset.ascSellingPlan = 'true';
        form.appendChild(field);
        fields.push(field);
      }

      fields.forEach(function (field) {
        field.value = String(plan.id);
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
      });
      return fields.some(function (field) { return String(field.value) === String(plan.id); });
    }

    async applyRecommendation() {
      var result = this.state.recommendation;
      if (!result) return;
      var button = this.querySelector('[data-asc-apply]');
      var status = this.querySelector('[data-asc-apply-status]');
      button.disabled = true;
      button.textContent = 'Applying…';

      await this.waitForKaching();
      var bundleApplied = await this.selectBundle(result.bundleRolls);
      await nextPaint();
      var subscriptionApplied = await this.selectSubscription();
      await nextPaint();
      this.applySellingPlan();
      var allApplied = bundleApplied && subscriptionApplied;
      var subscribeLabel = this.querySelector('.asc__subscribe');
      var selectionText = result.bundleRolls + (result.bundleRolls === 1 ? ' roll' : ' rolls') + ', ' +
        ((subscribeLabel && subscribeLabel.textContent.replace(/\s+/g, ' ').trim()) || 'Subscribe & Save') +
        ', delivered every ' + result.deliveryDays + ' days';

      this.handoff.hidden = false;
      if (allApplied) {
        this.handoff.textContent = 'Recommendation applied: ' + selectionText + '.';
        status.textContent = 'Recommendation applied.';
      } else {
        var missing = [];
        if (!bundleApplied) missing.push('bundle');
        if (!subscriptionApplied) missing.push('subscription');
        this.handoff.textContent = 'Select ' + selectionText + ' in the options below.';
        status.textContent = 'Please confirm the ' + missing.join(', ') + ' below.';
      }

      button.disabled = false;
      button.textContent = 'Apply Recommendation';
      var self = this;
      scope.setTimeout(function () { self.closeAndScrollToOptions(allApplied); }, allApplied ? 350 : 950);
    }

    closeAndScrollToOptions(preferAddToCart) {
      var optionsTarget = this.findOptionsTarget();
      var productInfo = this.findProductInfo() || document;
      var addToCart = productInfo.querySelector('.product-form__submit, [name="add"]');
      var target = preferAddToCart && addToCart ? addToCart : optionsTarget;
      if (target === this && addToCart) target = addToCart;
      this.close();
      scope.setTimeout(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 80);
    }
  }

  if (!scope.customElements.get('amuee-supply-calculator')) {
    scope.customElements.define('amuee-supply-calculator', AmueeSupplyCalculator);
  }
})(typeof window !== 'undefined' ? window : undefined);
